import Utils from '../utils';
import { ErrorType } from './ErrorType.enum';

const { Util } = Utils;
const contactNumber = Util.getFraudNumber();

export const ErrorData = () => ({
	// Populate all SWS/IM errors.
	swsim: [
		{
			code: 4522241,
			type: ErrorType.Custom,
			searchCriteria: 'invalid ratetoken',
			title: 'Print Cost Warning',
			description:
				'<p>The expected total print cost does not match the actual total print cost. This usually occurs when postal rates have changed since you last logged-in.</p><p>You can usually resolve this problem by refreshing your web browser.</p>',
			primaryButtonType: 'Refresh',
			primaryButtonText: 'Refresh',
		},
		{
			code: 4522242,
			type: ErrorType.Custom,
			searchCriteria: 'PromoPaper20NetStamps is not allowed',
			title: 'Error 4522242',
			description:
				'<p>These labels can only be used to print postage for domestic addresses.</p>',
		},
		{
			code: 4522243,
			type: ErrorType.Normal,
			title: 'Country Error',
			description: `<p>Stamps.com encountered an error while attempting to process the Ship To country.</p><p>Please re-enter the Ship To country and try again.</p>`,
		},
		{
			code: 4522262,
			type: ErrorType.Normal,
			title: 'Purchase Error',
			description: `<p>Stamps.com encountered an error while attempting to add funds. Please attempt to add funds again.</p><p>If this problem continues, please call Customer Support at ${contactNumber} Monday – Friday, 8 am – 8 pm Central Time.</p>`,
		},
		{
			code: 4522304,
			type: ErrorType.Normal,
			title: 'Invalid Ship To Address',
			description:
				'<p>The Ship To address is invalid.</p><p>Please verify the address is correct and try again.</p>',
		},
		{
			code: 4522337,
			type: ErrorType.Normal,
			title: 'Account Closed',
			description: `<p>Your account has been closed and cannot print.</p><p>If this problem continues, please call Customer Support at ${contactNumber} Monday – Friday, 8 am – 8 pm Central Time.</p>`,
		},
		{
			code: 4522344,
			type: ErrorType.Normal,
			title: 'Invalid Name',
			description:
				'<p>When shipping internationally, both the Ship From and Ship To address must have either a first and last name (with two characters each), or a company name.</p><p>Please provide this information and try again.</p>',
		},
		{
			code: 4522357,
			type: ErrorType.Normal,
			title: 'Account Status Error',
			description: `<p>Due to the current status of your account, Stamps.com cannot process your request to print.</p><p>If this problem continues, please call Customer Support at ${contactNumber} Monday – Friday, 8 am – 8 pm Central Time.</p>`,
		},
		{
			code: 4522358,
			type: ErrorType.Normal,
			title: 'Account Status Error',
			description: `<p>Due to the current status of your account, Stamps.com cannot process your request to add funds.</p><p>If this problem continues, please call Customer Support at ${contactNumber} Monday – Friday, 8 am – 8 pm Central Time.</p>`,
		},
		{
			code: 4522513,
			type: ErrorType.Normal,
			title: '10:30 AM Delivery Error',
			description: `<p>Stamps.com was unable to determine whether Priority Mail Express 10:30 AM Delivery is available for this destination. This may be due to a temporary issue; please try printing again. If this error persists, please try shipping without this special service.</p>`,
		},
		{
			code: 4522515,
			type: ErrorType.Normal,
			title: '10:30 AM Delivery Error',
			description: `<p>Stamps.com was unable to determine whether Priority Mail Express 10:30 AM Delivery is available for this destination. This may be due to a temporary issue; please try printing again. If this error persists, please try shipping without this special service.</p>`,
		},
		{
			code: 4523009,
			type: ErrorType.Normal,
			title: 'Account Status Error',
			description: `<p>Due to the current status of your account, Stamps.com cannot process your request to add funds.</p><p>If this problem continues, please call Customer Support at ${contactNumber} Monday – Friday, 8 am – 8 pm Central Time.</p>`,
		},
		{
			code: 5571337,
			type: ErrorType.Normal,
			description: `<p>Stamps.com encountered an error while attempting to save the new Ship From address on the server. Please try again</p><p>If this problem continues, please call Customer Support at ${contactNumber} Monday – Friday, 8 am – 8 pm Central Time.</p>`,
		},
		{
			code: 5571338,
			type: ErrorType.Normal,
			description: `<p>Stamps.com encountered an error while attempting to save the Ship From address on the server. Please try again</p><p>If this problem continues, please call Customer Support at ${contactNumber} Monday – Friday, 8 am – 8 pm Central Time.</p>`,
		},
		{
			code: -2147218430,
			type: ErrorType.Normal,
			title: 'Account Status Error',
			description: `<p>Due to the current status of your account, Stamps.com cannot process your request to add funds.</p><p>If this problem continues, please call Customer Support at ${contactNumber} Monday – Friday, 8 am – 8 pm Central Time.</p>`,
		},
		{
			code: -2147220459,
			type: ErrorType.Custom,
			title: 'Account Status Error',
		},
		{
			code: -2147220460,
			type: ErrorType.Normal,
			title: 'Insufficient Funds',
			description:
				'<p>You do not have sufficient funds in your account to cover the costs of this mailing. Please add more funds to print for this mailing.</p>',
		},
	],

	// Populate all GetRates error descriptions (code: 5177601).
	getRates: [
		{
			title: 'Invalid ZIP Code',
			searchCriteria: 'Invalid ToZIPCode',
			description:
				'<p>The Mail To ZIP code is invalid.</p><p>Please correct the Mail To address and try again.</p>',
		},
		{
			title: 'Invalid ZIP Code',
			searchCriteria: 'Invalid FromZIPCode',
			description:
				'<p>The Ship From ZIP code is invalid.</p><p>Please correct the Ship From address and try again.</p>',
		},
		{
			title: 'Invalid Ship Date',
			searchCriteria: 'Ship date must be within 3 days in the future',
			description:
				'<p>Please select a Ship Date no more than 3 days in the future.</p>',
		},
		{
			title: 'Invalid Ship Date',
			searchCriteria: 'is more than 7 days in the future',
			description:
				'<p>Please select a Ship Date no more than 7 days in the future.</p>',
		},
		{
			title: 'Invalid Ship Date',
			searchCriteria: 'is more than 30 days in the future',
			description:
				'<p>Please select a Ship Date no more than 30 days in the future.</p>',
		},
		{
			title: 'Invalid Ship Date',
			searchCriteria: 'is not in the future',
			description:
				'<p>The Ship Date cannot be in the past.</p><p>Please select a valid Ship Date and try again.</p>',
		},
		{
			title: 'Maximum Dimensions Exceeded',
			searchCriteria:
				'Cannot ship Parcel Select packages that have a combined length and girth of more than 130 inches',
			description:
				'<p>Length + 2x width + 2x height cannot exceed 130 inches when shipping a Parcel Select Ground package.</p>',
		},
		{
			title: 'Invalid Weight',
			searchCriteria: 'You have entered an invalid weight',
			description: '<p>Weight must be between 0.1 oz. and 70.0 lbs.</p>',
		},
		{
			title: 'Invalid Service',
			searchCriteria:
				'You cannot choose Delivery Confirmation (US-A-DC) with this Service Type and Large_Envelope_or_Flat',
			description:
				'<p>USPS Tracking cannot be used with First Class Large Envelopes and Flats.</p>',
		},
		{
			title: 'Invalid Service',
			searchCriteria:
				"Mail class 'PriorityMailInternational' is not available for the destination country",
			description:
				'<p>Priority Mail International service is not available for the Ship To country.</p><p>Please select a new service and try again.</p>',
		},
		{
			title: 'Invalid Service',
			searchCriteria: 'The specified mail class Critical is not available',
			description:
				'<p>Critical Mail service is not available for your account.<br><br>Please select a different service and try again.</p>',
		},
		{
			title: 'Invalid Service',
			searchCriteria: 'The specified mail class Express is not available',
			description:
				'<p>Priority Mail Express service is not available for your account.</p><p>Priority Mail Express service is not available for your account.</p>',
		},
		{
			title: 'Invalid Service',
			searchCriteria:
				'The mail class Priority cannot be used with package type Postcard for domestic mail',
			description:
				'<p>Priority Mail service is not available for use with Postcards.</p><p>Priority Mail service is not available for use with Postcards.</p>',
		},
		{
			title: 'Tracking Required',
			searchCriteria:
				'You must choose one of Signature Confirmation (US-A-SC) or Delivery Confirmation (US-A-DC) for a First Class package',
			description:
				'<p>You must select a Tracking service when shipping a First Class package.</p><p>Please select a Tracking service and try again.</p>',
		},
		{
			title: 'Tracking Required',
			searchCriteria:
				'You must choose exactly one of Signature Confirmation (US-A-SC) or Delivery Confirmation (US-A-DC) for a shipping label',
			description:
				'<p>A Tracking service is required in order to ship the package using the service you have selected.</p><p>Please select a Tracking service and try again.</p>',
		},
		{
			title: 'Maximum Value Exceeded',
			searchCriteria: 'Declared value must be $400 or less',
			description:
				'<p>You cannot ship items valued at more than $400 combined using the service you have selected.</p><p>You cannot ship items valued at more than $400 combined using the service you have selected.</p>',
		},
		{
			title: 'Maximum Weight Exceeded',
			searchCriteria: 'Mailpiece is over maximum weight of 0 lb 3.5 oz',
			description:
				'<p>Weight cannot exceed 3.5 oz. when mailing a First-Class letter.</p><p>Please correct the weight or select a different service.</p>',
		},
		{
			title: 'Invalid Rate',
			searchCriteria: 'USPS_Return_Receipt_Electronic requires USPS insurance',
			description:
				'<p>Electronic Return Receipt requires USPS insurance of more than $500.00.</p>',
		},
	],
});
